var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 197,
    viewBox: "0 0 198 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.621 0H30.3788C13.601 0 0 13.601 0 30.3788V166.36C0 183.137 13.601 196.738 30.3788 196.738H167.621C184.399 196.738 198 183.137 198 166.36V30.3788C198 13.601 184.399 0 167.621 0Z",
    fill: "#F60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.dd0bff872d139d98336ddec408a29dd8.svg";
export { ForwardRef as ReactComponent };